import { MessageMedium } from './GraphQLMessageMedium';

export enum SubscriptionPolicy {
  OptIn = 'OptIn',
  OptOut = 'OptOut',
  DoubleOptIn = 'DoubleOptIn',
}

export type FrequencyCap = {
  period: string; // Period
  numMessagesInPeriod: number;
};

export type MessageType = {
  id: number;
  createdAt: string;
  updatedAt: string;
  projectId: number;
  name: string;
  messageChannel?: MessageChannel;
  subscriptionPolicy: SubscriptionPolicy;
  rateLimitPerMin?: number;
  frequencyCap?: FrequencyCap;
};

export type MessageChannel = {
  id: number;
  createdAt: string;
  updatedAt: string;
  projectId: number;
  creatorUserId: string;
  name: string;
  channelType: string;
  messageMedium: MessageMedium;
  messageTypes: MessageType[];
};
